import { createFileRoute } from "@tanstack/react-router"

import CollectionsTab from "~/components/demand-2/portfolio/CollectionsTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Demand - Collections")
  return <CollectionsTab />
}
